import { render } from "./Newstrend.vue?vue&type=template&id=9be93978&scoped=true"
import script from "./Newstrend.vue?vue&type=script&lang=js"
export * from "./Newstrend.vue?vue&type=script&lang=js"

import "./Newstrend.vue?vue&type=style&index=0&id=9be93978&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be93978"]])

export default __exports__